import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconCheck = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.813 17.906'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M8.985,17.892 C8.724,17.892 8.473,17.788 8.287,17.604 L0.287,9.650 C-0.102,9.263 -0.105,8.634 0.281,8.244 C0.666,7.854 1.294,7.852 1.684,8.238 L8.933,15.445 L22.057,0.338 C22.415,-0.076 23.042,-0.120 23.456,0.241 C23.869,0.602 23.912,1.230 23.552,1.644 L9.733,17.550 C9.553,17.758 9.296,17.881 9.022,17.891 C9.010,17.892 8.998,17.892 8.985,17.892 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconCheck.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
